import React, { useEffect, useState } from "react";
import "./ScheduleFollowup.css"; // Import the CSS file
import UserGrid from "../AddMember/AddMember";
import ScheduleFollowUps from "../../ScheduleFollowUps/ScheduleFollowUps";
import { Modal, Button } from "antd";
import InviteMember from "app/scenes/Settings/components/InviteMember";
import { userInfo, workspaceInfo } from "app/config/States/users";
import { useRecoilState } from "recoil";
import { API_ENDPOINT_GET_USER_INFO } from "app/scenes/Auth/auth.constants";
import { apiGet } from "app/services/apiServices";
import { useNavigate } from "react-router-dom";
import Exemption from "../../Exempted_list/exemption";
import GSTCredentials from "app/scenes/Credentials/components/GSTCredentials";
import PrimaryNavBhilosa from "app/shared/PrimaryNavBhilosa";
import { UserAddOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import AddCCModal from "../../ScheduleFollowUps/AddCCModal";
import CCDetailsTable from "../../ScheduleFollowUps/DetailsTable";


const ScheduleFollowUpDetail = () => {
    const [activeTab, setActiveTab] = useState("Schedule follow-ups");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [workspaces, setWorkspaces] = useState([]);
    const [userDetails, setUserDetails] = useRecoilState(
        userInfo || { workspaces: [] }
    );

    const [searchQuery, setSearchQuery] = useState("");
    const [workspace, setWorkspace] = useRecoilState(workspaceInfo);

    const [selectedWorkspace, setSelectedWorkspace] = useState(workspace || null);
    const [selectedWorkspaceId, setSelectedWorkspaceId] = useState();

    useEffect(() => {
        // Fetch workspace data on mount
        const fetchUserInfo = async () => {
            try {
                const response = await apiGet(API_ENDPOINT_GET_USER_INFO, false);
                console.log("API Response:", response);
                if (response.status && response.data?.workspaces) {
                    setWorkspaces(response.data.workspaces);
                    setUserDetails({
                        ...userDetails,
                        workspaces: response.data.workspaces,
                    });
                    setWorkspace(response.data?.workspaces?.[0]?.name);
                    setSelectedWorkspace(response.data?.workspaces?.[0]?.name);
                    setFilteredOptions(response.data.workspaces); // Initialize filtered options
                    setSelectedWorkspaceId(response.data?.workspaces?.[0]?.id);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        };

        fetchUserInfo();
    }, []);

    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleMemberShipSuccess = () => {
        console.log("Membership successfully updated");
        setShowModal(false); // Close the modal on success
    };

    // Filter options based on the search query
    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        setFilteredOptions(
            workspaces.filter((workspace) =>
                workspace.name.toLowerCase().includes(query)
            )
        );
    };

    // Handle selection of a workspace
    const handleSelectOption = (workspace) => {
        setSelectedWorkspace(workspace.name);
        setWorkspace(workspace.name);
        setIsDropdownOpen(false);
        setSearchQuery("");
        setFilteredOptions(workspaces); // Reset the filtered options
    };

    const navigate = useNavigate();
    const goBack = () => {
        console.log("clicked")
        navigate('/vendorfollowup/memebersetting');
    };
    const [isAddCCModalVisible, setAddCCModalVisible] = useState(false);

    const handleAddCCSuccess = (newRow) => {
        // Do something with the new row, e.g., update a table
        console.log("New CC Added:", newRow);
    };
    const [isDetailPageVisible, setIsDetailPageVisible] = useState(false);
    const handleBackToSchedule = () => {
        setIsDetailPageVisible(false);
    };

    return (
        <div className="navBarMain" style={{ display: 'flex' }}>
            <PrimaryNavBhilosa />
            <div className="navBarMainContent">
                <div className="navbar">
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', gap: '15px' }}>
                            {activeTab === "Schedule follow-ups" && (
                                //    <ArrowLeftOutlined  style={{color:'#0A8394', marginBottom:'12px'}}
                                //    onClick={goBack}
                                //    />
                                <div
                                    onClick={goBack}
                                    style={{
                                        border: '1px solid #0A8394',
                                        borderRadius: '4px',
                                        padding: '4px',
                                        cursor: 'pointer',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '30px',
                                        width: '32px',
                                    }}
                                >
                                    <ArrowLeftOutlined style={{ color: '#0A8394', fontSize: '16px' }} />
                                </div>

                            )}
                            <h2 className="settinghead">Settings</h2>
                        </div>
                        {activeTab === "Schedule follow-ups" && (
                            <Button className="CCbtn" onClick={() => setAddCCModalVisible(true)}><UserAddOutlined style={{ width: '20px', height: '20px' }} />CC a Colleague</Button>
                        )}
                        {activeTab === "Members" && (
                            <Button className="CCbtn" onClick={() => setShowModal(true)}><UserAddOutlined style={{ width: '20px', height: '20px' }} />Add Member</Button>
                        )}
                    </div>
                </div>

                {/* Tabs */}
                <div className="tabs">
                    <div
                        className={`tab ${activeTab === "Schedule follow-ups" ? "active-tab" : ""
                            }`}
                        onClick={() => setActiveTab("Schedule follow-ups")}
                    >
                        Schedule follow-up CC member
                    </div>
                    <div
                        className={`tab ${activeTab === "Members" ? "active-tab" : ""}`}
                        onClick={() => setActiveTab("Members")}
                    >
                        Members
                    </div>
                    <div
                        className={`tab ${activeTab === "Your Exempted Vendors" ? "active-tab" : ""
                            }`}
                        onClick={() => setActiveTab("Your Exempted Vendors")}
                    >
                        Your Exempted Vendors
                    </div>
                </div>

                {/* Tab Content */}
                {/* <div className="tab-content" style={{flex:1 }}>
          {activeTab === "Members" && (
            <UserGrid selectedWorkspace={selectedWorkspaceId} />
          )}
          {activeTab === "Schedule follow-ups" && <ScheduleFollowUps />}
          {activeTab === "Your Exempted Vendors" && <Exemption />}
        </div> */}
                <div className="tab-content" style={{ flex: 1 }}>
                    {activeTab === "Members" && (
                        <UserGrid selectedWorkspace={selectedWorkspaceId} />
                    )}
                    {/* {activeTab === "Schedule follow-ups" && <ScheduleFollowUps />} */}
                    {activeTab === "Schedule follow-ups" && <CCDetailsTable />}
                    {activeTab === "Your Exempted Vendors" && <Exemption />}
                </div>
                <Modal
                    title="Add Members"
                    open={showModal}
                    footer={false}
                    onCancel={() => setShowModal(false)}
                    width={600}
                >
                    <InviteMember
                        onClose={() => setShowModal(false)}
                        onSuccess={handleMemberShipSuccess}
                    />
                </Modal>

                <AddCCModal
                    visible={isAddCCModalVisible}
                    onClose={() => setAddCCModalVisible(false)}
                    onSuccess={handleAddCCSuccess}
                />

            </div>
            {/* Navbar */}

        </div>
    );
};

export default ScheduleFollowUpDetail;

